<template>
    <div class="sign-in">
        <div class="sign-form">
            <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false">
               <van-field
                    v-model="form.email"
                    placeholder="E-mail"
                />
                <van-field
                    v-model="form.code"
                    placeholder="Code"
                >
                    <template #button>
                        <span class="code" v-if="newTimer">{{ newCount || 0}}s</span>
                        <span class="sendcode code" v-else @click="getCode">get</span>
                    </template>
                </van-field>
                <van-field
                    v-model="form.newPSW"
                    placeholder="New password"
                />
                <van-field
                    v-model="form.newPSW2"
                    placeholder="Confirm password"
                />
                <div class="vant-btn">
                    <van-button round block type="info"  native-type="submit">
                    Submit
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name:'Resetpassword',
    data(){
        return{
            form:{
                email:'',
                code:'',
                newPSW:'',
                newPSW2:'',
            },
            newCount: 0,
            timer: null,
            newTimer: null,
            codeKey:'',
        }
    },
    methods:{
        ...mapActions({
            sendEamilCode: "my/sendEamilCode",
            validateCode: "my/validateCode",
            checkEmailIsHas:'en/checkEmail',
            changPSW:'en/changPSW',
        }),
        async onSubmit(){
            if (!this.validatorEamil(this.form.email)) {
                this.$toast.fail('error Eamil');
                return;
            }
            if(this.form.newPSW != this.form.newPSW2) {
                this.$toast.fail('Passwords does not match');
                return;
            }
            let res = await this.checkEmailIsHas(this.form.email); //是否存在电子邮箱
            if(!res.data){
                this.$toast.fail('The Eamil not exist');
                return;
            }
            let checkRes =  await this.Checkphone();
            if(!checkRes) {
                return;
            };
            this.ChangePSw();
        },
        async ChangePSw(){
            let body = {
                email:this.form.email,
                password:this.form.newPSW,
            };
            let res = await this.changPSW(body);
            console.log(res,'-----');
            if(res.result){
                this.$toast.success("success");
                setTimeout(()=>{
                    this.$router.go(-1)
                },1500)
            } else {
                this.$toast.fail('fail')
            }

        },
        // 邮箱验证
        validatorEamil(val) {
            return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
        },
        // 获取邮箱验证码
        async getCode(){
            console.log(this.form.email,'123213')
            if (!this.validatorEamil(this.form.email)) {
                this.$toast.fail('error Eamil')
                return;
            } else {
                this.newDownTime();
                let res = await this.sendEamilCode({
                email: this.form.email
                });
                if (res.result) {
                    this.$toast.success("send success");
                    this.codeKey = res.data.key;
                } else {
                     this.$toast.fail('fail')
                }
            }
        },
        //验证手机号
        async Checkphone() {
            let res = await this.validateCode({
                key: this.codeKey,
                code: this.form.code
            });
            return new Promise((resolve, reject) => {
                if (res == true) {
                    this.resetDown();
                    resolve(true);
                } else {
                    this.$toast.fail('Validation failed')
                    this.resetDown();
                    resolve(false);
                }
            })
        },


        resetDown(){ // 重置验证码
            clearInterval(this.newTimer);
            this.newCount = 0;
            this.newTimer = null;
            this.form.code = "";
        },

        //新手机号倒计时
        newDownTime() {
            const newTIME_COUNT = 60;
            if (!this.newTimer) {
                this.newCount = newTIME_COUNT;
                const newTimer = setInterval(() => {
                let count = this.newCount;
                if (count > 0 && count <= newTIME_COUNT) {
                    count--;
                    this.newCount = count;
                } else {
                    clearInterval(this.newTimer);
                    this.newTimer = null;
                }
                }, 1000);
                this.newTimer = newTimer;
            }
        },

    }
    
}
</script>
<style lang="scss" scoped>
.sign{
    &-form{
        margin:1.4rem .3rem 0;
        .vant-btn{
            margin-top: .5rem;
            span{
                font-size: .3rem;
            }
        }
        .code{
            font-size: .3rem;
            color: #0190fe;
        }
    }
}
</style>